import { useModelService } from "@shared/services/api/hooks/useModelService";
import { useMemo } from "react";
import PublicEventRatingsRepository from "../repositories/PublicEventRatingsRepository";

const usePublicEventRatingsService = () => {
  const repository = useMemo(() => new PublicEventRatingsRepository(), []);
  const { usePaginated } = useModelService(repository);

  return {
    usePaginated,
  };
};

export default usePublicEventRatingsService;
